import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(
        Path,
        {
          d: "m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14",
          stroke: `${color}`
        }
      )
    }
  );
};
Icon.displayName = "Crown";
const Crown = memo(themed(Icon));
export {
  Crown
};
//# sourceMappingURL=crown.js.map
